exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-inner[data-v-43010c2c] {\n  background: rgba(0, 0, 0, 0.8);\n  color: var(--white);\n  height: 100%;\n}\n@media screen and (min-width: 700px) {\n.modal-inner[data-v-43010c2c] {\n    width: 80%;\n    max-width: 700px;\n    max-height: 80%;\n    height: auto;\n}\n}\n.modal-image[data-v-43010c2c] {\n  aspect-ratio: 1/1;\n  position: relative;\n  overflow: hidden;\n  width: 40%;\n}\n@media screen and (min-width: 700px) {\n.modal-image[data-v-43010c2c] {\n    width: 18%;\n}\n}", ""]);

// exports
